<template>
  <div class="container">
    <!-- <template> -->
    <div class="fixbox">
      <van-nav-bar :title="lang.myFavourites" left-arrow @click-left="prev"></van-nav-bar>
      <van-tabs @click="handleTabClick" v-model="subIndex" title-active-color="#ED1C24">
        <van-tab :title="lang.myFavourites"></van-tab>
        <van-tab :title="lang.proSub">
          <div class="fixbox_add">
            <span v-if="edata && edata.length > 0" @click="editSub">
              <img src="../assets/subediticon.png" :alt="lang.noInfo" class="sub_col sub_colr" />
              {{ lang.subEdit }}
            </span>
            <span @click="addSub">
              <img src="../assets/subaddicon.png" :alt="lang.noInfo" class="sub_col" />
              {{ lang.add }}
            </span>
            <span v-if="edata && edata.length > 0" @click="onClickShare">
              <img src="../assets/sub_share.png" :alt="lang.noInfo" class="sub_col sub_colr" />
              {{ lang.share }}
            </span>
          </div>
          <!-- 订阅条件 -->
          <div class="subBox">
            <ul class="flexStyle">
              <li v-for="(item, index) in edata" :key="index" @click="changeSubProperty(item, index)"
                :class="['contentStyle', { selected: selected == item.subscribeID }]">{{ item.title }}</li>
            </ul>
            <!-- <div> | </div> -->
            <div class="sortClass" @click="openOrder = true">
              <div class="sortImg">
                <img src="../assets/sub_sort.png" :alt="lang.noInfo" class="sub_col" />
              </div>
            </div>
          </div>
          <!-- 无订阅条件缺省页 -->
          <div v-if="showPropertyNull">
            <img src="../assets/nosub.png" :alt="lang.noInfo" class="none_col" />
            <p>{{ lang.noInfo }}</p>
          </div>
          <div v-else class="conBox">
            <!-- 订阅条件无数据缺省页 -->
            <div v-if="showNull" class="none-record">
              <img src="../assets/nopro.png" :alt="lang.noseaInfo" class="none_col" />
              <p>{{ lang.noseaInfo }}</p>
            </div>
            <!-- 符合订阅条件楼盘列表 -->
            <div v-else>
              <van-list v-model="loading" :finished="finished" @load="getSubProperty({},'load')" :loading-text="lang.loadingText">
                <historyList :houseList="subPropertyList" @cancelCollection="cancelCollection" @canaddCollection="canaddCollection" :mark="'subscribe'"></historyList>
              </van-list>
            </div>
          </div>
          <van-popup v-model="openOrder" position="bottom">
            <ul class="popul" v-if="subType == 1">
              <li @click="changeOrder(item.id)" v-for="item in saleSortList" :key="item.id"
                :class="['popli', { seled: orderId == item.id }]">
                <span>{{ item[language == 'en-us' ? 'nameEN' : language == 'zh-cn' ? 'nameCN' : 'name'] }}</span>
              </li>
            </ul>
            <ul class="popul" v-else>
              <li @click="changeOrder(item.id)" v-for="item in rentSortList" :key="item.dictionaryValue"
                :class="['popli', { seled: orderId == item.id }]">
                <span>{{ item[language == 'en-us' ? 'nameEN' : language == 'zh-cn' ? 'nameCN' : 'name'] }}</span>
              </li>
            </ul>
          </van-popup>
          <van-dialog class="favdialog" v-model="dialogShow" :confirm-button-text="lang.knowBut">
            <p class="keyWord">{{ lang.subLimit }}<br />{{ lang.subLimitAfter }}</p>
          </van-dialog>
          <!-- 底部弹出 -->
          <van-popup
            v-model:show="showBottom"
            position="bottom"
            :style="{ height: '60px', background: '#4C4C4C',textAlign: 'left' }"
            :overlay="false"
            :lock-scroll="false"
          >
            <span class="vanPopupCount">{{ count }} </span>
          </van-popup>
          <!-- </template> -->
        </van-tab>
      </van-tabs>

    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import historyList from '../components/history-list';
import pub from '../../common/public';
import lang from './../../common/language/subscribe';
const _conf = require('../../common/js/_conf');

export default {
  data() {
    return {
      collectionListAll: [],
      subPropertyNumber: 0,
      popupTimer: null,
      count: '',
      showBottom: false,
      propertyListId: [],
      subIndex: 1,
      shareItem: {},
      dialogShow: false,
      openOrder: false,
      lang,
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      edata: [],
      eDataList: [],
      subPropertyList: [],
      finished: false,
      loading: false,
      pageIndex: 1,
      showNull: false,
      selected: '',
      showPropertyNull: false,
      oldSearchList: {},
      subType: 1,//1售2租
      orderId: '',
      saleSortList: [
        {
          id: 0,
          name: '預設',
          nameCN: '预设',
          nameEN: 'Default',
          value: 'default'
        },
        {
          id: 14,
          name: '最新放盤',
          nameCN: '最新放盘',
          nameEN: 'Latest',
          value: 'publishTimeDesc'
        },
        {
          id: 3,
          name: '價錢：高至低',
          nameCN: '价钱：高到低',
          nameEN: 'Price: High to Low',
          value: 'salePriceDesc'
        },
        {
          id: 2,
          name: '價錢：低至高',
          nameCN: '价钱：低到高',
          nameEN: 'Price: Low to High',
          value: 'salePrice'
        },
        {
          id: 19,
          name: '價格減幅：高至低',
          nameCN: '价格减幅：高至低',
          nameEN: 'Price reduced % - High to Low',
          value: 'priceRatioDesc'
        },
        {
          id: 18,
          name: '價格減幅：低至高',
          nameCN: '价格减幅：低至高',
          nameEN: 'Price reduced % - Low to High',
          value: 'priceRatio'
        },
        {
          id: 7,
          name: '建築呎價：高至低',
          nameCN: '建筑尺价：高到低',
          nameEN: 'Unit Price/GFA: High to Low',
          value: 'buildingAvgPriceDesc'
        },
        {
          id: 6,
          name: '建築呎價：低至高',
          nameCN: '建筑尺价：低到高',
          nameEN: 'Unit Price/GFA: Low to High',
          value: 'buildingAvgPrice'
        },
        {
          id: 9,
          name: '實用呎價：高至低',
          nameCN: '实用尺价：高到低',
          nameEN: 'Unit Price/SFA: High to Low',
          value: 'saleableAvgPriceDesc'
        },
        {
          id: 8,
          name: '實用呎價：低至高',
          nameCN: '实用尺价：低到高',
          nameEN: 'Unit Price/SFA: Low to High',
          value: 'saleableAvgPrice'
        },
        {
          id: 11,
          name: '建築面積：高至低',
          nameCN: '建筑面积：高到低',
          nameEN: 'Gross Area: High to Low',
          value: 'buildingAreaDesc'
        },
        {
          id: 10,
          name: '建築面積：低至高',
          nameCN: '建筑面积：低到高',
          nameEN: 'Gross Area: Low to High',
          value: 'buildingArea'
        },
        {
          id: 13,
          name: '實用面積：高至低',
          nameCN: '实用面积：高到低',
          nameEN: 'Saleable Area: Hight to Low',
          value: 'saleableAreaDesc'
        },
        {
          id: 12,
          name: '實用面積：低至高',
          nameCN: '实用面积：低到高',
          nameEN: 'Saleable Area: Low to High',
          value: 'saleableArea'
        }
      ],
      rentSortList: [
        {
          id: 0,
          name: '預設',
          nameCN: '预设',
          nameEN: 'Default',
          value: 'default'
        },
        {
          id: 14,
          name: '最新放盤',
          nameCN: '最新放盘',
          nameEN: 'Latest',
          value: 'publishTimeDesc'
        },
        {
          id: 5,
          name: '價錢：高至低',
          nameCN: '价钱：高到低',
          nameEN: 'Price: High to Low',
          value: 'rentPriceDesc'
        },
        {
          id: 4,
          name: '價錢：低至高',
          nameCN: '价钱：低到高',
          nameEN: 'Price: Low to High',
          value: 'rentPrice'
        },
        {
          id: 19,
          name: '價格減幅：高至低',
          nameCN: '价格减幅：高至低',
          nameEN: 'Price reduced % - High to Low',
          value: 'priceRatioDesc'
        },
        {
          id: 18,
          name: '價格減幅：低至高',
          nameCN: '价格减幅：低至高',
          nameEN: 'Price reduced % - Low to High',
          value: 'priceRatio'
        },
        {
          id: 11,
          name: '建築面積：高至低',
          nameCN: '建筑面积：高到低',
          nameEN: 'Gross Area: High to Low',
          value: 'buildingAreaDesc'
        },
        {
          id: 10,
          name: '建築面積：低至高',
          nameCN: '建筑面积：低到高',
          nameEN: 'Gross Area: Low to High',
          value: 'buildingArea'
        },
        {
          id: 13,
          name: '實用面積：高至低',
          nameCN: '实用面积：高到低',
          nameEN: 'Saleable Area: High to Low',
          value: 'saleableAreaDesc'
        },
        {
          id: 12,
          name: '實用面積：低至高',
          nameCN: '实用面积：低到高',
          nameEN: 'Saleable Area: Low to High',
          value: 'saleableArea'
        }
      ],
    };
  },
  created() {
    this.getSubCon();
  },
  mounted() {
    this.$off('load', this.getSubProperty);
  },
  methods: {
    handleTabClick(index,title) {
      if(index === 0 && title === this.lang.myFavourites){
        this.$router.push('/collection/');
      }
    },
    addSub() {
      if (this.edata.length >= 10) {
        this.dialogShow = true
        return
      }
      const base = _conf.env_type == 4 ? 'https://sim.house730.com' : _conf.env_type == 3 ? 'https://www.house730.com' : 'https://uat.house730.com.cn'
      const type = this.language === 'zh-hk' ? '' : this.language + '/';
      location.href = `${base}/${type}subscribe/`;
    },
    editSub() {
      // 修改订阅
      this.$router.push('/editSubscribe');
    },
    changeOrder(id) {
      this.openOrder = false
      this.orderId = id
      this.finished = true
      if (JSON.stringify(this.oldSearchList) !== '{}') {
        this.oldSearchList.order = id
        this.getSubProperty(this.oldSearchList, 'filter')
      }
    },
    changeSubProperty(item, index) {
      this.collectionListAll = []
      this.subPropertyNumber = index
      this.orderId = ''
      delete item.searchPropertyRequest.order
      this.subType = item.propertyType
      this.loading = true;
      this.showNull = false;
      this.selected = item.subscribeID;
      this.shareItem = item;
      // this.finished = false
      this.getSubProperty(item.searchPropertyRequest, 'filter');
    },
    getSubCon() {
      this.axios.get(this.pub.getApi().GetUserSubscribesV2).then((res) => {
        if (res.data.code === 0) {
          this.edata = res.data.result;
          if (this.edata.length > 0) {
            this.edata[0].searchPropertyRequest.pageIndex = res.data.result[0].searchPropertyRequest.pageIndex == 0 ? 1 : this.edata[0].pageIndex;
            this.selected = res.data.result[0].subscribeID;
            this.subType = res.data.result[0].propertyType
            this.getSubProperty(this.edata[0].searchPropertyRequest, 'filter');
          } else {
            this.showPropertyNull = true;
          }
        }
      });
    },
    getSubProperty(searchlist, type) {
      if (type == 'filter') {
        this.subPropertyList = [];
        searchlist.pageIndex = 1;
        this.oldSearchList = searchlist;
      } else if (type != 'filter' && JSON.stringify(this.oldSearchList) !== '{}') {
        // 当列表滚动时,需要保持searchlist请求参数
        searchlist = this.oldSearchList;
      }
      this.axios
        .post(this.pub.getApi().SearchProperty, searchlist)
        .then((res) => {
          if (res.data.code === 0 && res.data.result) {
            if (searchlist.pageIndex === 1) {
              if (res.data.result.count === 0) {
                this.showNull = true;
                return;
              } else {
                if (res.data.result.count > 0) {
                  if(this.popupTimer) {
                    this.showBottom = false
                    clearTimeout(this.popupTimer);
                  }
                  this.showBottom = true
                  this.popupTimer = setTimeout(() => {
                    this.showBottom = false;
                  }, 3000);
                  this.count = this.lang.find + res.data.result.count + this.lang.properties
                }
                this.showNull = false;
              }
            }
            this.subPropertyList = this.subPropertyList.concat(res.data.result.data);
            this.subPropertyList = this.subPropertyList.map((item) => {
              if (!item.hasOwnProperty('property')) {
                return { property: item };
              }
              return item;
            });
            this.getSearchCollection(searchlist)
            searchlist.pageIndex++;
            this.loading = false;
            this.propertyListId = this.subPropertyList.map(item => {
              return item.property.propertyID.toString()
            })
            this.axios
            .post(this.pub.getApi().GetPropertyUserInfoList, {
              propertyIds:  this.propertyListId
            })
            .then(rem => {
              this.subPropertyList = this.subPropertyList.map((item, index) => {
                return {
                  ...item,
                  ...rem.data.result[index]
                };
              });
            })
            .catch(err => {});
            if (this.subPropertyList.length >= res.data.result.count) {
              this.finished = true;
            } else {
              this.finished = false
            }
          }
        })
        .catch((err) => { });
    },
    getSearchCollection(item) {
      this.axios
        .post(this.pub.getApi().SearchCollection, {
            sourceType: item.rentalType === 1 ? 'sale' : 'rent',
            pageIndex: item.pageIndex,
            pageCount: 15,
            isShowSourceInfo: true
          })
        .then(res => {
          if(res.data.code === 0 && res.data.result.data) {
            this.collectionListAll = this.collectionListAll.concat(res.data.result.data)
            this.subPropertyList = this.subPropertyList.map(item => {
              const matchingCollection = this.collectionListAll.find(collectionItem => collectionItem.property.propertyID === item.property.propertyID);
              if (matchingCollection !== undefined) {
                return { ...item, collectionID: matchingCollection.collectionID }
              } else {
                return { ...item, collectionID: '' }
              }
            });
          }
        })
        .catch(err => {});
    },
    prev() {
      // this.$router.push('/');
      this.$router.go(-1);
    },
    onClickShare() {
      let copyVaule = ''
      if (this.subPropertyNumber) {
        copyVaule = this.edata[this.subPropertyNumber].shareUrl
      } else {
        copyVaule = this.edata[0].shareUrl
      }
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', copyVaule);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
      }
      // 删除'虚拟'DOM
      document.body.removeChild(input);
      Toast(this.lang.copySuccessText)
    },
    cancelCollection(id, index, type) {
      const type2 = type === 1 ? 'Sale' : 'Rent'
      this.axios
        .get(this.pub.getApi().DeleteCollection, {
          params: {
            collectionId: id.collectionID,
            sourceType: type2,
          }
        })
        .then(res => {
          if (res.data.code === 0) {
            this.subPropertyList[index].collectionID = '';
          }
        });
    },
    canaddCollection(index, estateId, type) {
      const token = this.pub.getCookie('cEVaUDFrZ1kd0RA');
      const type2 = type === 1 ? 'Sale' : 'Rent'
      if (token) {
        this.axios
          .post(this.pub.getApi().AddCollection, {
            sourceID: estateId,
            sourceType: type2,
          })
          .then((res) => {
            this.subPropertyList[index].collectionID = res.data.result;
          });
      }
    },
  },
  components: {
    historyList,
  },
};
</script>

<style scoped lang="scss">
.fixbox [class*='van-hairline']::after {
  border-bottom: 1px solid #e3e4e6;
}

.van-nav-bar {
  height: 44px;
  border-bottom: 0px solid #e3e4e6;
  border-width: 0 0 !important;
}

::v-deep .van-hairline--top-bottom::after {
  border-width: 0;
}

.van-nav-bar__title {
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #333333 !important;
}
/deep/ .van-dialog {
  border-radius: 12px;
}

/deep/.favdialog .van-dialog__content {
  height: 116px;
  line-height: 116px;
  color: #000000;
  border-bottom: 1px solid #dddddd;
}

/deep/.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #3391FF;
}

.keyWord {
  height: 116px;
  display: flex;
  line-height: 28px;
  flex-direction: column;
  justify-content: center;
  margin: 0 12px;
}

.popul {
  background-color: #fff;
  padding: 0 16px;

  .popli {
    color: #333;
    display: block;
    font-size: 14px;
    height: 44px;
    width: 100%;
    border-bottom: 1px solid #eee;
    height: 44px;
    line-height: 44px;
    text-align: center;
  }

  .seled {
    color: #ed1c24;
  }
}

.none_col {
  width: 120px;
  height: 120px;
  margin-top: 50px;
}

.sortClass {
  .sortImg {
    font-size: 12px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 20px;
      width: 20px;
    }
  }
}

// .conBox{
//     margin-top:95px;
// }
.fixbox {

  // padding-left:15px;
  // position:fixed;
  // top:0px;
  .fixbox_add {
    text-align: left;
    height: 52px;
    background: #F9F9F9;

    span {
      line-height: 52px;
    }
  }

  span {
    display: inline-block;
    margin-left: 15px;
  }

  .sub_col {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  .sub_colr {
    width: 18px;
    height: 18px;
  }
}

.subBox {
  display: flex;
  align-items: center;
  padding: 0 16px;

  // position:fixed;
  // top:44px;
  .flexStyle {
    padding: 12px 0;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /* 设置超出滚动 */
    overflow-x: auto;
    width: 90%;
    margin-right: 18px;
  }

  .contentStyle {
    /* width:150px; */
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    display: inline-block;
    background: #f4f4f4;
    margin-right: 6px;
    font-size: 14px;
    color: #333333;
    /* 超出滚动的关键，没有它元素会自动缩小，不会滚动 */
    flex-shrink: 0;
  }

  .selected {
    background: #106fc4;
    color: #fff;
  }
}

.vanPopupCount {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0;
  line-height: 60px;
}

::-webkit-scrollbar {
  /* 隐藏滚动条 */
  display: none;
}

::v-deep .van-tabs__wrap {
  border-width: 1px 0 !important;
  border: 0px solid #DDDDDD;
}

::v-deep .van-tab--active {
  font-weight: 700;
}

::v-deep .van-tab {
  font-weight: 700;
}
</style>
